import { DateTime } from 'luxon';
import { useSelector } from 'react-redux';
import LanguageSlice from '../common/slices/LanguageSlice';
import { DEFAULT_LOCALE } from '../constants/misc.constants';

export default function useDate(
    date?: string,
    format?: Intl.DateTimeFormatOptions,
    locale?: string,
): string | null {
    if (!date) {
        return null;
    }

    const currentLocale = useSelector(LanguageSlice.state.getLocale);
    const _locale = locale || currentLocale || DEFAULT_LOCALE;

    return DateTime.fromISO(date, {
        locale: _locale.toLowerCase(),
    }).toLocaleString(format || DateTime.DATETIME_MED);
}
